export type { ITag } from "./interfaces";
export { useGetTags } from "./useGetTags";
